import { render } from "./FormularioDocumento.vue?vue&type=template&id=a702d48c&scoped=true"
import script from "./FormularioDocumento.vue?vue&type=script&lang=js"
export * from "./FormularioDocumento.vue?vue&type=script&lang=js"

import "./FormularioDocumento.vue?vue&type=style&index=0&id=a702d48c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a702d48c"]])

export default __exports__